import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-SPVG36Q3W8"); // substitua pelo seu Measurement ID
};

export const trackPageView = (path:string) => {
    ReactGA.send({ hitType: "pageview", page: path });
};

export const trackLoginEvent = (method: string = "standard") => {
    ReactGA.event({
        category: "engagement",
        action: "login",
        label: method,
    });
};

export const setUserId = (userId: string) => {
    ReactGA.set({ user_id: userId });
};
